import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import commonActions from "../../../../redux/reducers/common/actions";

const WelcomeBanner = () => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(commonActions.setWelcomeBannerDismissed(true));
  };

  const features = [
    {
      icon: <img src="/assets/images/bannericon1.png" alt="Collaborate" style={{ width: 32, height: 32 }} />,
      title: "Collaborate seamlessly",
    },
    {
      icon: <img src="/assets/images/bannericon2.png" style={{ width: 32, height: 32 }} />,
      title: "Manage all your projects in one place",
    },
    {
      icon: <img src="/assets/images/bannericon3.png" alt="Get paid" style={{ width: 32, height: 32 }} />,
      title: "Deliver and get paid on time",
    },
  ];

  return (
    <Box
        sx={{
          background: "linear-gradient(135deg, #6681FF 0%, #0B30DE 100%)",
          borderRadius: 3,
          p: 4,
          mb: 4,
          mt: 4,
          position: "relative",
          overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"10\" cy=\"60\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"90\" cy=\"40\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grain)\"/></svg>')",
          opacity: 0.3,
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: -8,
          right: -8,
          zIndex: 10,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          color: "#1F2937",
          width: 36,
          height: 36,
          border: "2px solid rgba(255, 255, 255, 0.3)",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          "&:hover": {
            backgroundColor: "white",
            transform: "scale(1.05)",
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: { xs: "column", md: "row" }, gap: { xs: 3, md: 0 } }}>
        {/* Left side - Welcome text */}
        <Box sx={{ position: "relative", zIndex: 1, flex: "0 0 40%" }}>
          <Typography
            variant="h3"
            sx={{
              color: "white",
              fontWeight: 500,
              mb: 2,
              fontSize: { xs: "1.5rem", sm: "1.8rem", md: "24px" },
              lineHeight: 1.2,
            }}
          >
            We're excited to have you on board!
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: "rgba(255, 255, 255, 0.9)",
              fontWeight: 500,
              fontSize: { xs: "1rem", sm: "1.1rem", md: "16px" },
              lineHeight: 1.4,
            }}
          >
            Reno is your dedicated partner for smooth, successful projects, every step of the way.
          </Typography>
        </Box>

        {/* Right side - Feature cards */}
        <Box sx={{ 
          flex: "0 0 60%", 
          display: "flex", 
          gap: 2, 
          justifyContent: "flex-end",
          flexWrap: "nowrap",
          minWidth: 0
        }}>
            {features.map((feature, index) => (
              <Card
                key={index}
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.08)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.15)",
                  borderRadius: 2,
                  flex: "1 1 0",
                  minWidth: 0,
                  maxWidth: "200px",
                  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
                  transition: "all 0.3s ease",
                }}
              >
                <CardContent
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    textAlign: "left",
                    width: "100%",
                    minWidth: 0,
                  }}
                >
                  <Box sx={{ mb: 1.5 }}>
                    {feature.icon}
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "0.85rem",
                      lineHeight: 1.3,
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      hyphens: "auto",
                    }}
                  >
                    {feature.title}
                  </Typography>
                </CardContent>
              </Card>
            ))}
        </Box>
      </Box>
    </Box>
  );
};

export default WelcomeBanner;
